import { render, staticRenderFns } from "./user_navleft.vue?vue&type=template&id=704e992c&scoped=true&"
import script from "./user_navleft.vue?vue&type=script&lang=js&"
export * from "./user_navleft.vue?vue&type=script&lang=js&"
import style0 from "./user_navleft.vue?vue&type=style&index=0&id=704e992c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e992c",
  null
  
)

export default component.exports